//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------
//  -- Features -----------------------
import React, { useEffect, useState } from 'react';
//  -- Constants ----------------------
import {ArrowRightRounded, CheckCircleRounded} from '@mui/icons-material';
import { Tooltip } from 'antd';
import Loading from 'components/Loading';
import { filter, get } from 'lodash';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';
import { handleListGame } from 'store/one_game/thunks';
import { IGameHome8 } from "utils/assets/images";
import StudyLoader from './StudyLoaader';

const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    className: "center",
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    responsive: [
        {
            breakpoint: 1092,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

export default function StudentStudy({ bookId, pageId, startGame, gameInitLoader, teacherId, oneStudyType, newMaskId }) {
    const dispatch = useDispatch();
    const [games, setGames] = useState([])
    const [isLoading, setLoading] = useState(true);
    const [selectedGame, setSelectedGame] = useState({})

    const loadData = async () => {
        setLoading(true)
        const { data } = await dispatch(handleListGame(teacherId, bookId, pageId, 'my_study', '1study'));
        if (data && Array.isArray(data) && oneStudyType === 'flash_card') {
            const filterFlashcard = filter(data, obj => obj.study_metadata?.type === 'flash_card');
            setGames(filterFlashcard)
        } else if (data && Array.isArray(data) && oneStudyType === 'quiz') {
            const filterQuiz = filter(data, obj => obj.study_metadata?.type === 'quiz');
            setGames(filterQuiz)
        } else if (data && Array.isArray(data)) {
            setGames(data)
        }
        setLoading(false);
    }

    useEffect(() => {
        loadData();
    }, [pageId, oneStudyType])

    if (isLoading) {
        return (<StudyLoader />);
    }
    if (games.length == 0) {
        return (<div class="skeleton-wrapper">
            <div class="skeleton-card" style={{ textAlign: "center" }}>No study available!</div>
        </div>
        )
    }

    return (
        <>
            <Slider {...settings}>
                {games.map((item, index) => {
                    const image_url = item.media_urls ? item.media_urls.image : IGameHome8
                    const isGameLoading = gameInitLoader && selectedGame.game_id === item.game_id;
                    const studyMetaData = get(item, 'study_metadata', '') || {};
                    return (
                        <div className='myUnitsGm' key={item.id} style={{ overflow: "hidden" }}>
                            <div className='myUnitsBnr draftImage-game frameStyle'>
                                <img
                                    src={image_url}
                                    alt=""
                                    className='imageStyle'
                                />
                                {item?.status === 'false' && (
                                    <div className='draftText-game'>Draft</div>
                                )}
                            </div>
                            <div className='myUnitsTxt'>
                                <div className='myUnitsInfo'>
                                    {/* <label>{item.display_name || 'Untitled'}</label> */}
                                    {item?.display_name && item.display_name.length > 20 ? (
                                        <Tooltip title={item.display_name}>
                                            <label className='text-dark'>{item?.display_name.slice(0, 20) + '...'}</label>
                                        </Tooltip>
                                    ) : (
                                        <label className='text-dark'>{item?.display_name || 'Untitled'}</label>
                                    )}
                                    <p>{item?.category?.category_name || "--"}</p>
                                    {newMaskId ? (
                                        <span>Pg. {newMaskId || '--'}</span>
                                    ) : (
                                        <span>Pg. {item?.sub_category?.category_name || item?.sub_category?.reference_id || '--'}</span>
                                    )}
                                    <span>{`No. of Questions: ${item?.question_length ?? 0}`}</span>
                                </div>
                                <div className='myUnitsBtns'>
                                    <a className={`study-cursor`}>{studyMetaData?.type === 'flash_card' ? "Flashcard" : "Quiz"}</a>
                                    <a
                                        onClick={() => {
                                            if (isGameLoading || gameInitLoader) {
                                                return false;
                                            }
                                            if (item?.status === 'true' && item?.question_length > 0) {
                                                setSelectedGame(item);
                                                startGame(item);
                                            }
                                        }}
                                        className={`BtnsStart ${item?.status !== 'true' || item?.question_length == 0 ? "btn-disabled-game" : ''}`}>
                                        <ArrowRightRounded />{gameInitLoader && selectedGame.game_id === item.game_id ? <Loading size={12} white /> : null} start
                                    </a>
                                </div>
                                <div className='myUnitsBtm'><p><CheckCircleRounded /> My Study</p></div>
                            </div>
                        </div>
                    )
                })}
            </Slider>
        </>
    )
}